import React from "react";

const CareersContentSection = () => {
  return (
    <section className="w-full bg-gradient-to-b from-[#eef4f4] to-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20 space-y-32">

        {/* ===== Block 1: Image + Glass Floating Card ===== */}
        <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

          {/* Image */}
          <div className="flex justify-center lg:justify-start">
            <img
              src="/assets/career/careers-team.webp"
              alt="Careers team"
              className="
                w-full max-w-md
                rounded-3xl
                object-cover
                aspect-[4/3]
                shadow-[0_20px_40px_rgba(0,0,0,0.15)]
                transition-transform duration-300
                hover:scale-[1.02]
              "
            />
          </div>

          {/* Floating Card */}
          <div className="relative lg:absolute lg:right-0 lg:top-1/2 lg:-translate-y-1/2 lg:max-w-xl">
            <div
              className="
                bg-white/90 backdrop-blur
                rounded-2xl
                shadow-[0_25px_60px_rgba(0,0,0,0.2)]
                p-7 sm:p-9
                border border-white/40
              "
            >
              <span className="inline-block mb-3 text-sm font-semibold text-[#0b4864] tracking-wide">
                CAREERS AT DTA
              </span>

              <h3 className="text-[#0b4864] font-bold text-xl sm:text-2xl leading-tight">
                We welcome passionate, skilled individuals ready to make an
                impact.
              </h3>

              <p className="mt-4 text-gray-700 text-sm sm:text-base leading-7">
                Digital Transformation Associates is a fast-growing consulting
                firm focused on delivering advanced Supply Chain consulting
                services and technology solutions. We bring deep expertise
                across SAP (IBP, APO, MM, PP, EWM, TM, MDM/MDG, CRM/TPM, S/4HANA),
                Cloud & DevOps, Data Engineering, Big Data & Analytics, and
                modern application development using Java, JavaScript, Angular,
                React, and UI/UX design. Our capabilities also extend to Machine
                Learning, Generative AI, Sustainability Modeling, and other
                emerging technologies.
              </p>
            </div>
          </div>
        </div>

        {/* ===== Block 2: Image + Content ===== */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">

          {/* Image */}
          <div className="flex justify-center lg:justify-start">
            <img
              src="/assets/career/careers-collaboration.webp"
              alt="Team collaboration"
              className="
                w-full max-w-lg
                rounded-3xl
                object-cover
                aspect-[16/10]
                shadow-[0_20px_40px_rgba(0,0,0,0.15)]
                transition-transform duration-300
                hover:scale-[1.02]
              "
            />
          </div>

          {/* Content */}
          <div>
            <span className="inline-block mb-2 text-sm font-semibold text-[#e14b3b] tracking-wide">
              WHY CHOOSE US
            </span>

            <h3 className="text-[#0b4864] font-bold text-xl sm:text-2xl">
              A place where careers grow with purpose
            </h3>

            <p className="mt-4 text-gray-700 text-sm sm:text-base leading-7 max-w-xl">
              At Digital Transformation Associates, we believe our people are
              our greatest strength. We provide opportunities to grow through
              meaningful, challenging projects while fostering a close-knit,
              inclusive culture. Our supportive work environment, competitive
              benefits, and long-term vision help our employees—and their
              families—thrive together.
            </p>

            {/* Optional CTA */}
            <button
              className="
                mt-6
                inline-flex items-center
                rounded-md
                bg-[#0b4864]
                px-6 py-3
                text-sm font-semibold text-white
                transition
                hover:bg-[#093b52]
              "
            >
              Explore Open Roles
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareersContentSection;
